var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-options-list"},_vm._l((_vm.items),function(item,index){return _c('w-options-list-item',{key:`WOptions-list-item-${index}`,class:`${index > 0 ? 'mt-2':''}`,attrs:{"icon":item.icon,"title":item.title,"subtitle":item.subtitle}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }